import { AxiosResponse } from "axios";

import { appConstants } from "../config/app-constants";
import InitApi from "./init";
import { IChangePasswordForm, ILoggedInUserRoot } from "../config/interfaces";

class LoggedInUserApi {
	static _instance: LoggedInUserApi;

	static getInstance = () => {
		if (this._instance) {
			return this._instance;
		}
		this._instance = new LoggedInUserApi();
		return this._instance;
	};

	_apiSvc;

	constructor() {
		this._apiSvc = InitApi.getInstance();
	}

	getMyProfile = async (): Promise<ILoggedInUserRoot> => {
		const response = await this._apiSvc.get(`${appConstants.apiUrl}/user/my-profile`);
		return response.data;
	};

	updateMyProfile = async (data: any): Promise<AxiosResponse> => {
		return this._apiSvc.put(`${appConstants.apiUrl}/user/my-profile`, data);
	};

	changeMyPassword = async (data: IChangePasswordForm): Promise<AxiosResponse> => {
		return this._apiSvc.put(`${appConstants.apiUrl}/user/change-password`, data);
	};
}

export default LoggedInUserApi;
